import React from 'react';
import styled from 'styled-components';
import { Artist } from 'types/artist';

interface ReleaseArtistsProps {
  release: string;
  artists: Artist[];
}

export const ReleaseArtists: React.FC<ReleaseArtistsProps> = props => {
  const { release, artists } = props;
  return (
    <Container>
      <Highlight>{release ?? '-'}</Highlight>
      <div>{artists.length ? artists.map((artist) => artist.name).join(", ") : '-'}</div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
`;

const Highlight = styled.span`
  font-weight: 600;
`;
